const getters = {
	token: state => state.user.token,
	mobile: state => state.user.mobile,
	auth_status: state => state.user.auth_status,
	baseURL:  state => process.env.NODE_ENV=='development'?'/api':process.env.VUE_APP_BASE_API
}
export default getters